export default __webpack_public_path__ + "8d963497ffc6bd91c790dc763e127a92.png";